import { createApi } from "@reduxjs/toolkit/query/react";
import { createApiConfig } from "../../createApiConfig";

export const customerCampaignPlatformApi = createApi({
  reducerPath: "customerCampaignPlatformApi",
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ["CustomerCampaignPlatform"],
  endpoints: (builder) => ({
    listCustomerCampaignPlatform: builder.query({
      query: (params) => ({
        url: `/campaigns/customer-campaign-platforms/`,
        params,
      }),
      providesTags: ["CustomerCampaignPlatform"],
    }),

    retrieveCustomerCampaignPlatform: builder.query({
      query: (id) => `/campaigns/customer-campaign-platforms/${id}/`,
      providesTags: ["CustomerCampaignPlatform"],
    }),

    createCustomerCampaignPlatform: builder.mutation({
      query: (data) => ({
        url: `/campaigns/customer-campaign-platforms/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CustomerCampaignPlatform"],
    }),

    updateCustomerCampaignPlatform: builder.mutation({
      query: ({ id, data }) => ({
        url: `/campaigns/customer-campaign-platforms/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["CustomerCampaignPlatform"],
    }),

    deleteCustomerCampaignPlatform: builder.mutation({
      query: (id) => ({
        url: `/campaigns/customer-campaign-platforms/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["CustomerCampaignPlatform"],
    }),
  }),
});

export const {
  useListCustomerCampaignPlatformQuery,
  useLazyListCustomerCampaignPlatformQuery,
  useRetrieveCustomerCampaignPlatformQuery,
  useCreateCustomerCampaignPlatformMutation,
  useUpdateCustomerCampaignPlatformMutation,
  useDeleteCustomerCampaignPlatformMutation,
} = customerCampaignPlatformApi;
